"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Copied from AngularJS. In order to prevent AngularJS from dispatching another browser location change event (and
 * adding a new entry to the history) we should encode our URI components the same way as AngularJS.
 *
 * We need our custom method because encodeURIComponent is too aggressive and doesn't follow
 * http://www.ietf.org/rfc/rfc3986.txt with regards to the character set (pchar) allowed in path
 * segments:
 *    segment       = *pchar
 *    pchar         = unreserved / pct-encoded / sub-delims / ":" / "@"
 *    pct-encoded   = "%" HEXDIG HEXDIG
 *    unreserved    = ALPHA / DIGIT / "-" / "." / "_" / "~"
 *    sub-delims    = "!" / "$" / "&" / "'" / "(" / ")"
 *                     / "*" / "+" / "," / ";" / "="
 */
function encodeUriSegment(val) {
    return encodeUriQuery(val, true).
        replace(/%26/gi, '&').
        replace(/%3D/gi, '=').
        replace(/%2B/gi, '+');
}
exports.encodeUriSegment = encodeUriSegment;
/**
 * This method is intended for encoding *key* or *value* parts of query component. We need a custom
 * method because encodeURIComponent is too aggressive and encodes stuff that doesn't have to be
 * encoded per http://tools.ietf.org/html/rfc3986:
 *    query         = *( pchar / "/" / "?" )
 *    pchar         = unreserved / pct-encoded / sub-delims / ":" / "@"
 *    unreserved    = ALPHA / DIGIT / "-" / "." / "_" / "~"
 *    pct-encoded   = "%" HEXDIG HEXDIG
 *    sub-delims    = "!" / "$" / "&" / "'" / "(" / ")"
 *                     / "*" / "+" / "," / ";" / "="
 */
function encodeUriQuery(val, pctEncodeSpaces) {
    return encodeURIComponent(val).
        replace(/%40/gi, '@').
        replace(/%3A/gi, ':').
        replace(/%24/g, '$').
        replace(/%2C/gi, ',').
        replace(/%3B/gi, ';').
        replace(/%20/g, (pctEncodeSpaces ? '%20' : '+'));
}
exports.encodeUriQuery = encodeUriQuery;
/**
 * Copied from AngularJS. We need to decode slashes in our paths to prevent AngularJS from rewriting the URL and
 * adding a new value to the browser history (see also the comment for encodeUriSegment).
 *
 * Encode path using encodeUriSegment, ignoring forward slashes.
 *
 * @param {string} path Path to encode
 * @returns {string}
 */
function encodePath(path) {
    var segments = path.split('/');
    var i = segments.length;
    while (i--) {
        // decode forward slashes to prevent them from being double encoded
        segments[i] = encodeUriSegment(segments[i].replace(/%2F/g, '/'));
    }
    return segments.join('/');
}
exports.encodePath = encodePath;
//# sourceMappingURL=util.js.map